import { ARENA_KINDS, type ArenaKind } from "@townsy/contracts";
import type { VenueClientModule } from "../types";
import { ArenaCompact, ArenaHud } from "./ArenaHud";
import { buildArena3d } from "./scene";

/**
 * The Sports Park stadiums on the client (ADR-0044): the stadium in 3D (field, stands, crowd, players, ball, big
 * scoreboard), the overlay (scoreboard, countdown, Cheer, crowd meter, predictions, seats) and the compact strip.
 */
function arenaClient(kind: ArenaKind): VenueClientModule {
  return { kind, build3d: (ctx) => buildArena3d(ctx), Hud: ArenaHud, Compact: ArenaCompact };
}

export const ARENA_CLIENTS = Object.fromEntries(ARENA_KINDS.map((k) => [k, arenaClient(k)])) as Record<ArenaKind, VenueClientModule>;

/** Titles of the stadium panels. */
export const ARENA_TITLES: Readonly<Record<ArenaKind, string>> = {
  football_stadium: "Townsy Titans Stadium",
  soccer_stadium: "Townsy FC Stadium",
  baseball_stadium: "Townsy Sluggers Ballpark",
  basketball_arena: "Townsy Hoopers Arena",
  hockey_arena: "Townsy Blizzard Ice Arena",
};
